import CommonTabContentWrap from "@home/pages/studio/components/CommonTabContentWrap";
import CommonPermissionWrap from "@home/pages/studio/components/CommonPermissionWrap";
import CommonTab from "@home/pages/studio/components/CommonTab";

export default {
  CommonPermissionWrap,
  CommonTab,
  CommonTabContentWrap
};